import axios from 'axios'
import cookies from '@/services/cookies'
import store from '@/store'
import * as Sentry from '@sentry/vue'

function baseURL (API_ROOT) {
  return `${API_ROOT}/api/personal-cabinet/`
}

function setStorageUrl (urlParams) {
  const storageValue = urlParams.get('revstor')
  if (storageValue === 'rteam') {
    cookies.set('STORAGE_URL', 'https://storage-review.growfood.pro/storage1/review-rteam')
  } else if (storageValue === 'fteam') {
    cookies.set('STORAGE_URL', 'https://storage-review.growfood.pro/storage1/review-f-team')
  } else if (storageValue === 'core') {
    cookies.set('STORAGE_URL', 'https://storage-review.growfood.pro/storage1/review-core')
  } else if (['true', ''].includes(storageValue)) {
    cookies.set('STORAGE_URL', 'https://storage-review.growfood.pro/storage1/data')
  } else {
    cookies.set('STORAGE_URL', process.env.VUE_APP_STORAGE_URL)
  }
}

function setApiRootFromParams () {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('preprod')) {
    switch (urlParams.get('preprod')) {
      case 'rteam': {
        cookies.set('API_ROOT', 'https://review-rteam-admin-review.growfood.pro')
        break
      }
      case 'gteam': {
        cookies.set('API_ROOT', 'https://review-g-team-admin-review.growfood.pro')
        break
      }
      case 'fteam': {
        cookies.set('API_ROOT', 'https://review-f-team-admin-review.growfood.pro')
        break
      }
      case 'mobile': {
        cookies.set('API_ROOT', 'https://review-mobile-admin-review.growfood.pro')
        break
      }
      case 'core': {
        cookies.set('API_ROOT', 'https://review-core-admin-review.growfood.pro')
        break
      }
      case 'master': {
        cookies.set('API_ROOT', 'https://master-admin-review.growfood.pro')
        break
      }
      default: {
        cookies.set('API_ROOT', 'https://review-develop-admin-review.growfood.pro')
        break
      }
    }
  }

  setStorageUrl(urlParams)

  if (urlParams.has('local')) {
    cookies.set('API_ROOT', 'https://admin.growfood.local')
  }
  if (urlParams.has('prod')) {
    cookies.set('API_ROOT', 'https://admin.growfood.pro')
  }
}

function initApiRoot () {
  let API_ROOT = process.env.VUE_APP_API_ROOT
  setApiRootFromParams()
  if (cookies.get('API_ROOT')) {
    API_ROOT = cookies.get('API_ROOT')
  }
  return API_ROOT
}

export { baseURL, initApiRoot }

const axiosInstance = axios.create({
  baseURL: baseURL(initApiRoot()),
  crossDomain: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

let isRequestRetryAllowed = true
axiosInstance.interceptors.response.use(function (response) {
  return response
}, async function (error) {
  if (error?.response?.status === 403 && error?.response?.config.url.includes('/send-sms')) {
    Sentry.captureException(error)
  }

  let errorConfig
  if (isRequestRetryAllowed && error?.response?.status === 403 && !error?.response?.config.url.includes('/efst')) {
    try {
      await store.dispatch('efst/getFrontSmsToken', true)
    } catch (error) {
      console.error(error)
    } finally {
      isRequestRetryAllowed = false
      errorConfig = error.config
    }
  } else {
    isRequestRetryAllowed = true
  }

  if (errorConfig) {
    try {
      const data = JSON.parse(errorConfig.data)
      const oldEfstToken = data?.analyticalData?.cookie?._efst
      if (oldEfstToken) {
        data.analyticalData.cookie._efst = cookies.get('_efst')
        errorConfig.data = JSON.stringify(data)
      }
    } catch (error) {
      console.error(error)
    }

    return new Promise((resolve) => {
      resolve(axios(errorConfig))
    })
  }

  return Promise.reject(error)
})

export default axiosInstance
